/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Section_ActionsInputs */

const cs_automation_section_actions = /** @type {(inputs: Automation_Section_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce`)
};

const en_automation_section_actions = /** @type {(inputs: Automation_Section_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Automation_Section_ActionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_section_actions = /** @type {((inputs?: Automation_Section_ActionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Section_ActionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_section_actions(inputs)
	return cs_automation_section_actions(inputs)
});